import tracker from '../../../libs/tracker';
import getPayload from './clickEventPayload';

const handleClickEvent = (element) => () =>
  tracker.trackBabbelTracker('gui:interacted', 1, getPayload(element));

function initialize(element) {
  if (element) {
    element.addEventListener('click', handleClickEvent(element));
  }
}

export default {
  initialize,
  handleClickEvent
};
